






























































import Vue, { PropType } from 'vue';
import SelectChipsFromRightSlide from '@/components/chips/SelectChipsFromRightSlide.vue';
import ChipsElement from '@/components/chips/ChipsElement.vue';
import FieldButton from '@/components/form/FieldButton.vue';
import FieldInput from '@/components/form/FieldInput.vue';
import { IChipsData } from '@/types';
import { TNewDataWithId } from '@/types/publisher/inventory';
import { IChipTreeData } from '@/utils/ChipsTree';

export default Vue.extend({
  name: 'PlacementAutoContent',
  components: {
    SelectChipsFromRightSlide,
    ChipsElement,
    FieldButton,
    FieldInput,
  },

  props: {
    placementId: {
      type: String,
      required: true,
    },
    unwantedCategories: {
      type: Array as PropType<Array<string>>,
      required: true,
    },
    unwantedLinks: {
      type: Array as PropType<Array<string>>,
      required: true,
    },
    category: {
      type: Array as PropType<Array<IChipTreeData>>,
      required: true,
    },
  },

  watch: {
    unwantedLinks(newValue, oldValue) {
      if (newValue.length !== oldValue.length) {
        this.localUnwantedLinks = [...newValue];
      }
    },
  },

  methods: {
    createLink(): void {
      this.showUnwantedContentAddButton = false;
    },
    addCategories(categories: Array<IChipsData>): void {
      this.changeEvent('unwantedCategories', categories);
    },
    addUnwantedLink(): void {
      if (this.unwantedLink) {
        this.localUnwantedLinks.push(this.unwantedLink);
        const unwantedLinks: Array<string> = this.localUnwantedLinks.map(
          (l: string): string => l
        );
        this.changeEvent('unwantedLinks', unwantedLinks);
      }
    },
    closeUnwantedLink(): void {
      this.resetPlacementUnwantedContents();
    },
    deleteUnwantedLink(linkIndex: number): void {
      if (this.localUnwantedLinks.length) {
        this.localUnwantedLinks.splice(linkIndex, 1);
        const unwantedLinks: Array<string> = this.localUnwantedLinks.map(
          (l: string): string => l
        );
        this.changeEvent('unwantedLinks', unwantedLinks);
      }
    },
    resetPlacementUnwantedContents(): void {
      this.showUnwantedContentAddButton = true;
      this.unwantedLink = '';
    },
    changeEvent(propName: string, value: any) {
      const newDataWithId: TNewDataWithId = {
        id: this.placementId,
        propName,
        value,
      };

      this.$store.dispatch('publisher/updatePlacementData', newDataWithId);
      this.resetPlacementUnwantedContents();
    },
  },

  data() {
    return {
      showUnwantedContentAddButton: true,
      localUnwantedLinks: this.unwantedLinks as Array<string>,
      unwantedLink: '',
    };
  },
});
